import React, { useEffect, useState } from "react";
import moment from "moment";
// import MarketingBar from "../../components/marketingBar";
// import OnTimeBanner from "../../components/selfHelp/trayContent/OTG";
import { fetchGDSBooking } from "../../network";

// import { fetchGDSBooking, fetchMarketingCards } from "../../network";
import styles from "./gdsSelfhelp.module.scss";
import signupImage from "../../images/signupImage.png";
import {
  // marketingCardsPriority,
  b2cURL,
  isStage,
  mixPanelToken
} from "../../config";
import { message, Modal } from "antd";
import Fetch from "../../utils/fetch";
import mixpanel from "mixpanel-browser";

const SelfHelp = props => {
  const [loading, updateLoading] = useState(true);
  const [booking, updateBookingData] = useState({});
  // const [marketingCardsData, updateMarketingCardsData] = useState({});
  const [showSOSModal, setSOSModal] = useState(false);
  const [showEditBooking, setEditBooking] = useState(false);

  const isRedirectRequired = () => {
    const query = new URLSearchParams(props.location.search);
    return query.get("demandSource") == "B2CANDROID";
  };

  // const getMarketingCards = async () => {
  //   try {
  //     const path = "/marketing/selfHelpPage?platform=SELFHELPPAGE";
  //     const marketingCards = await fetchMarketingCards(path, {});

  //     updateMarketingCardsData(marketingCards);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const getBooking = async bookingCode => {
    try {
      const bookingQuery = `bookingCode=${bookingCode}`;

      const gdsBookingArr = await fetchGDSBooking(bookingQuery, {});

      const gdsBooking = gdsBookingArr[0];

      gdsBooking.fromStationTime = moment(gdsBooking.fromStationDate).format(
        "hh:mm a | D MMM"
      );

      gdsBooking.toStationTime = moment(gdsBooking.toStationDate).format(
        "hh:mm a| D MMM"
      );
      const seats = gdsBooking.tripChart;

      gdsBooking.tripId = gdsBooking.gdsOperatorTrip._id;

      gdsBooking.seats = seats;

      updateBookingData(gdsBooking);
      return gdsBooking;
    } catch (err) {
      console.log(err);
    }
  };

  const getFirstLoadData = async () => {
    try {
      const bookingCode = props.match.params.bookingCode;
      await getBooking(bookingCode);

      updateLoading(false);
      // getMarketingCards();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFirstLoadData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const callMarshall = () => {
    const number =
      booking.gdsOperatorTrip && booking.gdsOperatorTrip.busAssignmentDetails
        ? booking.gdsOperatorTrip.busAssignmentDetails.busHostPhoneNumber
          ? parseInt(
              booking.gdsOperatorTrip.busAssignmentDetails.busHostPhoneNumber
            )
          : parseInt(
              booking.gdsOperatorTrip.busAssignmentDetails.driverPhoneNumber
            )
        : null;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Call Marshal", {
      crew_assigned: !!number,
      inventory: "GDS",
      inventory_type: "GDS",
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.fromCity.name,
      to_city: booking.toCity.name,
      booking_source: booking.demandSource,
      from_station: booking.fromStationName,
      to_station: booking.toStationName,
      trip_date: moment(booking.fromStationDate).format("YYYY-MM-DD")
    });
    if (isNaN(number)) {
      message.error("Sorry! no bus is assigned");
    } else {
      window.open(`tel:+91-${number}`);
    }
  };

  const openSOSWhatsApp = () => {
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Chat Support", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.fromCity.name,
      to_city: booking.toCity.name,
      from_station: booking.fromStationName,
      to_station: booking.toStationName,
      trip_date: moment(booking.fromStationDate).format("YYYY-MM-DD"),
      booking_source: booking.demandSource,
      view_from: "Self Help Page",
      inventory: "GDS",
      inventory_type: "GDS"
    });
    window.open(
      "https://api.whatsapp.com/send?phone=918287009889&text=zingbus"
    );
  };

  const raiseSOS = async () => {
    try {
      let url = `/gds/booking/raiseSOS/`;
      const marshalNumber =
        booking.gdsOperatorTrip && booking.gdsOperatorTrip.busAssignmentDetails
          ? booking.gdsOperatorTrip.busAssignmentDetails.busHostPhoneNumber
            ? parseInt(
                booking.gdsOperatorTrip.busAssignmentDetails.busHostPhoneNumber
              )
            : parseInt(
                booking.gdsOperatorTrip.busAssignmentDetails.driverPhoneNumber
              )
          : null;
      const options = {
        method: "post",
        data: {
          bookingCode: booking.bookingCode,
          number: booking.mobileNo,
          marshalNumber: isNaN(marshalNumber) ? undefined : marshalNumber
        }
      };

      const response = await Fetch(url, options);
      if (Array.isArray(response) && response.length > 0) {
        mixpanel.init(mixPanelToken, { debug: isStage });
        mixpanel.track("SOS Confirm", {
          mobile_no: booking.mobileNo,
          pnr: booking.bookingCode,
          from_city: booking.fromCity.name,
          to_city: booking.toCity.name,
          from_station: booking.fromStationName,
          to_station: booking.toStationName,
          trip_date: moment(booking.fromStationDate).format("YYYY-MM-DD"),
          booking_source: booking.demandSource,
          inventory: "GDS",
          inventory_type: "GDS"
        });

        let gdsbooking = { ...booking, isSOSAlertInserted: true };
        updateBookingData(gdsbooking);
        setSOSModal(false);
      } else {
        message.error("Something went wrong");
      }
    } catch (err) {
      message.error(err);
    }
  };

  const showEdit = value => {
    if (value === true) {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Modify Booking", {
        mobile_no: booking.mobileNo,
        pnr: booking.bookingCode,
        from_city: booking.fromCity.name,
        to_city: booking.toCity.name,
        from_station: booking.fromStationName,
        to_station: booking.toStationName,
        trip_date: moment(booking.fromStationDate).format("YYYY-MM-DD"),
        booking_source: booking.demandSource,
        inventory: "GDS",
        inventory_type: "GDS"
      });
    }
    setEditBooking(value);
  };

  const openLink = value => {
    const { bookingCode, mobileNo, demandSource } = booking;

    mixpanel.init(mixPanelToken, { debug: isStage });

    let track = "";

    if (value === "Point_Change") {
      track = "Modify-Change BP/DP Clicked";
    } else if (value === "Reschedule_Booking") {
      track = "Modify-Reschedule Booking Clicked";
    } else {
      track = "Modify-Update Contact Details Clicked";
    }

    mixpanel.track(track, {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.fromCity.name,
      to_city: booking.toCity.name,
      booking_source: booking.demandSource
    });

    let link = b2cURL;
    link += `/selfhelp/login?bookingCode=${bookingCode}&mobileNo=${mobileNo}&updateType=${value}&bookingType=GDS&demandSource=${demandSource}`;
    window.open(link, "_self");
  };

  const checkDemandSource = () => {
    const currentUrl = window.location.href;
    const urlObject = new URL(currentUrl);
    const params = new URLSearchParams(urlObject.search);
    const hasDemandSource = params.has("demandSource");

    return hasDemandSource;
  };
  const dateFormat = "hh:mm A";
  const dayFormat = "MMM DD";

  const isAndroid = isRedirectRequired();

  const fromStationTime = booking.fromStationTime;

  let showModifyBooking = true;
  const isOnlineBooking =
    booking.demandSource == "B2CIOS" ||
    booking.demandSource == "B2CWEB" ||
    booking.demandSource == "B2CANDROID" ||
    booking.demandSource == "OTA";
  const isApp = checkDemandSource();

  if (
    booking.agentId ||
    !isOnlineBooking ||
    !!booking.rescheduledToBookingCode ||
    !!booking.rescheduledFromBookingCode
  ) {
    showModifyBooking = false;
  }

  if (fromStationTime - 60 * 60 * 1000 < Date.now()) {
    showModifyBooking = false;
  }

  if (isApp) {
    showModifyBooking = false;
  }
  const now = Date.now();
  const showSOS =
    now >= booking.fromStationDate - 20 * 60 * 1000 &&
    now <= booking.toStationDate + 1 * 60 * 60 * 1000;

  // const isPrime = !!booking.zingStorePassRewardId;

  const toggleSOS = () => {
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("SOS Clicked", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.fromCity.name,
      to_city: booking.toCity.name,
      from_station: booking.fromStationName,
      to_station: booking.toStationName,
      trip_date: moment(booking.fromStationDate).format("YYYY-MM-DD"),
      booking_source: booking.demandSource,
      view_from: "SOS Confirmation",
      inventory: "GDS",
      inventory_type: "GDS"
    });

    setSOSModal(!showSOSModal);
  };

  const hideSOS = () => {
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("SOS Cancelled", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.fromCity.name,
      to_city: booking.toCity.name,
      from_station: booking.fromStationName,
      to_station: booking.toStationName,
      trip_date: moment(booking.fromStationDate).format("YYYY-MM-DD"),
      booking_source: booking.demandSource,
      inventory: "GDS",
      inventory_type: "GDS"
    });
    setSOSModal(!showSOSModal);
  };

  return (
    <div className={styles.selfHelpContainer}>
      {showSOS ? (
        <div
          className={
            booking.isSOSAlertInserted ? styles.sosInitiated : styles.SOS
          }
          onClick={() => (booking.isSOSAlertInserted ? null : toggleSOS)}
        >
          <img
            src={
              booking.isSOSAlertInserted
                ? "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/SOSRaised.svg"
                : "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/SOS.svg"
            }
            alt="SOS"
          />
          <span>
            {booking.isSOSAlertInserted ? "SOS Raised" : "SOS Emergency"}
          </span>
        </div>
      ) : null}

      <Modal
        centered
        width={"80%"}
        visible={showSOSModal}
        footer={null}
        onCancel={() => hideSOS()}
      >
        <div className={styles.SOSModal}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/SOS/request.svg"
            alt="info"
          />
          <p>Initiate SOS </p>
          <p>
            Initiate SOS services only in case of an emergency and use{" "}
            <b>WhatsApp chat for faster query resolution.</b> Once SOS is
            initiated our team will try to reach you as soon as possible.
          </p>
          <div onClick={() => openSOSWhatsApp()}>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/SOS/whatsapp.svg"
              alt="whatsApp"
            />
            <span>WhatsApp Chat</span>
          </div>
          <div onClick={() => raiseSOS()}>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/SOS/info.svg"
              alt="sos"
            />
            <span>Initiate SOS</span>
          </div>
          <div onClick={() => hideSOS()}>
            <span>Cancel</span>
          </div>
        </div>
      </Modal>
      <div className={styles.mapBanner}>
        <span>Tracking details not available</span>
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.stationDetails}>
          <div className={styles.wrapper}>
            <div className={styles.stationNames}>
              <div>
                <span>{booking.fromCity.name}</span>
                <div>
                  <span>
                    {" "}
                    {moment(booking.fromStationDate).format(dateFormat)}
                  </span>
                  <div className={styles.ellipse} />
                  <span>
                    {moment(booking.fromStationDate).format(dayFormat)}
                  </span>
                </div>
              </div>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/arrow-forward.svg"
                alt="arrow-forward"
              />
              <div>
                <span>{booking.toCity.name}</span>
                <div>
                  <span>
                    {moment(booking.toStationDate).format(dateFormat)}
                  </span>
                  <div className={styles.ellipse} />
                  <span>{moment(booking.toStationDate).format(dayFormat)}</span>
                </div>
              </div>
            </div>
            <div className={styles.dashed} />
            <div className={styles.pnrView}>
              <div>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/ticket/ticket.svg"
                  alt="ticket"
                />
                <div>
                  <span>PNR</span>
                  <span>
                    {booking.rescheduledFromBookingCode &&
                    booking.connectingBookingCode
                      ? booking.rescheduledFromBookingCode
                      : booking.connectingBookingCode
                      ? booking.connectingBookingCode
                      : booking.bookingCode}
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.buttons}>
              <div onClick={callMarshall}>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/telephone.svg"
                  alt="Call"
                />
                <span>Call Marshal</span>
              </div>
            </div>
            <div
              className={styles.modify}
              style={{ display: showModifyBooking ? "" : "none" }}
              onClick={() => showEdit(true)}
            >
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/sefhelp/editBooking/edit.svg "
                alt="edit"
              />
              <span>Modify Booking</span>
            </div>
          </div>
        </div>
        {/* {isPrime ? <OnTimeBanner booking={booking} /> : null} */}

        <div style={{ visibility: showEditBooking ? null : "hidden" }}>
          <div className={styles.overlay} onClick={() => showEdit(false)}></div>
          <div className={styles.editBooking}>
            <div className={styles.edit_header}>
              <span>Modify Booking</span>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/close_small.svg"
                alt="close"
                onClick={() => showEdit(false)}
              />
            </div>

            <hr />
            <div
              className={styles.selectable}
              onClick={() => openLink("Reschedule_Booking")}
            >
              <div>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/calendar.svg"
                  alt="calendar"
                />
                <span>Reschedule Booking </span>
              </div>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/rightArrow.svg"
                alt="arrow"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.tripDetail}>
        <p>Bus Timeline</p>
        <div className={styles.stations}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/NoStation.svg"
            alt="stationImage"
          />

          <div className={styles.details}>
            <span>Boarding at</span>
            <span>
              {booking.fromStationName}, {booking.fromCity.name}
            </span>
            <span> {moment(booking.fromStationDate).format(dateFormat)}</span>
          </div>
        </div>

        <div className={styles.connectingStrip}>
          <div />
        </div>
        <div className={styles.stations}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/NoStation.svg"
            alt="stationImage"
          />

          <div className={styles.details}>
            <span>Drop at</span>
            <span>
              {" "}
              {booking.toStationName}, {booking.toCity.name}
            </span>
            <span>{moment(booking.toStationDate).format(dateFormat)}</span>
          </div>
        </div>
      </div>
      <div className={styles.seatsWrapper}>
        <p>Your Seats</p>
        <div className={styles.seats}>
          {booking.seats.map((obj, index) => (
            <div key={index}>
              <span>
                {obj.name} - {obj.seatLabel}
              </span>
            </div>
          ))}
        </div>
      </div>
      {!isAndroid ? (
        <img className={styles.signUpBanner} src={signupImage} />
      ) : null}
      {/* <div className={styles.banner}>
        <p className={styles.offerHeader}>Best Offers For Your Journey</p>
        {marketingCardsPriority.map(key =>
          marketingCardsData[key] ? (
            <div key={key}>
              <MarketingBar booking={booking} data={marketingCardsData[key]} />
            </div>
          ) : (
            <div key={key} />
          )
        )}
      </div> */}
    </div>
  );
};

export default SelfHelp;
